import React, { useEffect, useState, useRef } from "react";
import Helper from "helper/Common_Helper";
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { useLocation } from 'react-router-dom';

dayjs.extend(isSameOrAfter);

function AdminViewTable({ TableData, currentPage, totalPages, handlePageChange }) {
    const location = useLocation();
    const [eventsData, setEventsData] = useState([]);
    const [participantsTotal, setParticipantsTotal] = useState(0);
    const [schoolTotal, setSchoolTotal] = useState(0);
    const [themeTotal, setThemeTotal] = useState(0);
    const [subthemeTotal, setSubThemeTotal] = useState(0);
    const [exportTotal, setExportTotal] = useState(0);
    const [exportTotalDistrict, setExportTotalDistrict] = useState(0);
    const today = dayjs().startOf('day');
    const hasFetchedTotal = useRef(false);  

    const params = new URLSearchParams(location.search);
    let storedState = params.get('state');

    if (!storedState || storedState === 'null') {
        storedState = localStorage.getItem('filterDataState');
    }
    if (!storedState) {
        // console.log("State not found in URL or localStorage.");
    }
    
    useEffect(() => {
        setEventsData(TableData);
    }, [TableData]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    scrollToTop();

    useEffect(() => {
        const themesName = params.get('themeLabel') || 0;
    
        if (hasFetchedTotal.current) return;
    
        const fetchDataForTheme = async (theme_name) => {
            console.log('49999 inside theme',theme_name)
            try {
                const response = await fetch('https://ecoclubs.education.gov.in/api/get-all-events', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ theme_name }),
                });
                const data = await response.json();

                console.log('data', data);
    
                if (data.status === 'success') {
                    setParticipantsTotal(data.totalParticipantsCount);
                    setSchoolTotal(data.totalSchools);
                    setThemeTotal(data.totalThemes);
                    setSubThemeTotal(data.totalSubthemes);
                    setExportTotal(data.data);
    
                    hasFetchedTotal.current = true;
                } else {
                    console.error("Failed to fetch participants total or invalid response:", data);
                }
            } catch (error) {
                console.error('Error fetching data for theme:', error);
            }
        };
    
        const fetchDataForDistrict = async (district) => {
            console.log('799999 inside district')
            try {
                const response = await fetch('https://ecoclubs.education.gov.in/api/get-all-events', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ district }),
                });
                const data = await response.json();
    
                if (data.status === 'success') {
                    setParticipantsTotal(data.totalParticipantsCount);
                    setSchoolTotal(data.totalSchools);
                    setThemeTotal(data.totalThemes);
                    setSubThemeTotal(data.totalSubthemes);
                    setExportTotalDistrict(data.data);
    
                    hasFetchedTotal.current = true;
                } else {
                    console.error("Failed to fetch participants total or invalid response:", data);
                }
            } catch (error) {
                console.error('Error fetching data for district:', error);
            }
        };
    
        const fetchDataForThemeAndStateWise = async (theme_name, state) => {
            console.log('10000777777 inside theme and state')
            try {
                const response = await fetch('https://ecoclubs.education.gov.in/api/get-all-events', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ theme_name ,  state }), 
                });
                const data = await response.json();
        
                if (data.status === 'success') {
                    setParticipantsTotal(data.totalParticipantsCount);
                    setSchoolTotal(data.totalSchools);
                    setThemeTotal(data.totalThemes);
                    setSubThemeTotal(data.totalSubthemes);
                    setExportTotal(data.data);
        
                    hasFetchedTotal.current = true;
                } else {
                    console.error("Failed to fetch participants total or invalid response:", data);
                }
            } catch (error) {
                console.error('Error fetching data for theme:', error);
            }
        };
        
    
        if (storedState && themesName) {
            fetchDataForThemeAndStateWise(themesName,storedState);  // both are available
        } else {
            if (eventsData.length > 1) {
                let firstThemeName = eventsData[0]?.theme_name;
                let firstDistrict = eventsData[0]?.district;
                let firstState = eventsData[0]?.state;
                let isSameTheme = true;
                let isSameDistrict = true;
    
                let isSameState = true; // New flag to track if the state is consistent
                for (let i = 1; i < eventsData.length; i++) {
                    const currentThemeName = eventsData[i]?.theme_name;
                    const currentDistrict = eventsData[i]?.district;
                    const currentState = eventsData[i]?.state; // Get the current state value
                
                    if (currentThemeName !== firstThemeName) {
                        isSameTheme = false;
                    }
                    if (currentDistrict !== firstDistrict) {
                        isSameDistrict = false;
                    }
                    if (currentState !== firstState) {
                        isSameState = false; // Check if the state is consistent
                    }
                    
                    if (!isSameTheme && !isSameDistrict && !isSameState) {
                        break;
                    }
                }
                
    
                if (isSameTheme && isSameDistrict) {
                    fetchDataForDistrict(firstDistrict);
                } else if (isSameDistrict) {
                    fetchDataForDistrict(firstDistrict);
                } else if (isSameTheme) {
                    fetchDataForTheme(firstThemeName);
                } else if(isSameState){
                    fetchDataForThemeAndStateWise(themesName,storedState);
                } else {
                    fetchDataForTheme('');
                }
            } else if (eventsData.length === 1) {
                const themeName = eventsData[0]?.theme_name;
                const district = eventsData[0]?.district;
    
                if (themeName && district) {
                    fetchDataForDistrict(district);
                } else if (themeName) {
                    fetchDataForTheme(themeName);
                } else if (district) {
                    fetchDataForDistrict(district);
                } else {
                    fetchDataForTheme('');
                }
            }
        }
    }, [eventsData, location.state, storedState]);

    const pageTotalParticipants = eventsData.reduce((sum, item) => {
        return sum + (item?.number_participant_age3to8 || 0)
            + (item?.number_participant_age8to11 || 0)
            + (item?.number_participant_age11to14 || 0)
            + (item?.number_participant_age14to18 || 0)
            + (item?.number_participant_age18plus || 0);
    }, 0);

    const downloadCSV = () => {
        const headers = [
            "S.no,School Name,State/UT/AB,District,Event Name,Life Theme,Sub Theme,Host Faculty,Total Participants,Event Date,Current Status,Impact,Likes,Dislikes"
        ];
    
        const rows = (exportTotal.length ? exportTotal : exportTotalDistrict).map((item, index) => {

            const row = [
                index + 1,
                item.school_name || '',
                item.state || '',
                item.district || '',
                item.event_name || '',
                item.theme_name || '',
                (item.sub_themes || []).join(' | '),
                (item.facultiesData || []).map(f => f.teacher_name || "Principal").join(' | '),
                ((item.number_participant_age3to10 || 0) + (item.number_participant_age10to15 || 0) + (item.number_participant_age15to18 || 0) + (item.number_participant_age18plus || 0)),
                formatDate(item.event_date) || '',
                item.status === 2 ? "Completed - Approved" : item.status === 0 ? "Completed - Rejected" : item.status === 1 && dayjs(item.event_date).isSameOrAfter(today) ? "Ongoing" : "Completed",
                "100",
                item.like_count || 0,
                item.dislike_count || 0
            ];
            return row.join(",");
        });        
    
        const csvContent = [headers, ...rows].join("\n");
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Event_data.csv";
        link.click();
        URL.revokeObjectURL(url);
    };
    
    const formatDate = (date) => {
        if (!date) return '';
        const formattedDate = dayjs(date).format('DD-MM-YYYY HH:mm');
        return formattedDate;
    };    

    return (
        <>
            <div className="content">
                <div className="btmTableDivIn">
                    <div className="tableTopDiv">
                    <div className="dwnldexel">
                         <button onClick={downloadCSV} className="btn btn-primary">Download CSV</button>
                        </div>
                        <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                            <table rules="all" className="table">
                                <thead className="text-primary" style={{ position: 'sticky', top: '0', backgroundColor: '#ffffff', zIndex: '1000', boxShadow: '0 2px 2px -1px rgba(0, 0, 0, 0.4)' }}>
                                    <tr className="tblHdngOne">
                                        <th>S.no</th>
                                        <th>School Name</th>
                                        <th>State/UT/AB</th>
                                        <th>District</th>
                                        <th>Event Name</th>
                                        <th>Life Theme</th>
                                        <th>Sub Theme</th>
                                        <th>Host Faculty</th>
                                        <th>Total Participants</th>
                                        <th>Event Date and Time</th>
                                        <th>Current Status</th>
                                        <th>Impact</th>
                                        <th>Likes</th>
                                        <th>Dislikes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                    {eventsData && eventsData.length > 0 ? (
                                        eventsData
                                            .map((item, i) => (
                                                <tr key={i}>
                                                    <td>{(currentPage-1)*10+i + 1}</td>
                                                    <td>{item.school_name}</td>
                                                    <td>{item.state}</td>
                                                    <td>{item.district}</td>
                                                    <td>{item.event_name}</td>
                                                    <td>{item.theme_name}</td>
                                                    <td>
                                                        {item.sub_themes && item.sub_themes.length > 0 ? (
                                                            item.sub_themes.map((faculty, i) => (
                                                                <React.Fragment key={i}>
                                                                    <span>{` ${faculty || ""}`}</span><br />
                                                                </React.Fragment>
                                                            ))
                                                        ) : (<span>Principal</span>)}
                                                    </td>
                                                    <td>
                                                        {item.facultiesData && item.facultiesData.length > 0 ? (
                                                            item.facultiesData.map((faculty, i) => (
                                                                <React.Fragment key={i}>
                                                                    <span>{` ${faculty?.teacher_name || "Principal"}`}</span><br />
                                                                </React.Fragment>
                                                            ))
                                                        ) : (<span>Principal</span>)}
                                                    </td>
                                                    <td>{(item?.number_participant_age8to11 || 0) +(item?.number_participant_age14to18 || 0) + (item?.number_participant_age11to14 || 0) + (item?.number_participant_age3to8 || 0) + (item?.number_participant_age18plus || 0)}</td>
                                                    <td>{Helper.formatDate(item.event_date)}</td>
                                                    <td>{item.status === 2 ? "Completed - Approved" : item.status === 0 ? "Completed - Rejected" : item.status === 1 && dayjs(item.event_date).isSameOrAfter(today) ? "Ongoing" : "Completed"}</td>
                                                    <td>100</td>
                                                    <td>{item?.like_count || 0}</td>
                                                    <td>{item?.dislike_count || 0}</td>
                                                </tr>
                                            ))
                                    ) : <tr><td colSpan={14} className="text-center">Data not Found.</td></tr>
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan="8" className="text-right font-weight-bold">Total Participants(Page Count):</td>
                                        <td>{pageTotalParticipants}</td>
                                        <td colSpan="5"></td>
                                    </tr>
                                </tfoot>
                            </table>
                            <div className="stackHldrCntDiv">
                                <div className="row">
                                    <div className="col-12 col-lg-6 stackLft animate__animated animate__fadeInLeft customWidth">
                                        <h2 className="sbHdng">Key Statistics</h2>
                                        <div className="stackLftIn">
                                            <ul>
                                                <li>
                                                    Unique Schools <span>{schoolTotal}</span>
                                                </li>
                                                <li>
                                                    Unique themes <span>{themeTotal}</span>
                                                </li>
                                                <li>
                                                    Unique Sub themes <span>{subthemeTotal}</span>
                                                </li>
                                                <li>
                                                    Total participants  <span>{participantsTotal}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {totalPages > 1 && (
                            <div className="mb-3">
                                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}> Previous </button>
                                <span>Page {currentPage} of {totalPages}</span>
                                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}> Next </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default AdminViewTable;
